import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showToast } from "./toastAction";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";
import { uploadImages } from "../../utils/uploadFiles";

const getUsers = (setLoading) => async (dispatch) => {
    if (setLoading) {
        setLoading(true);
    }
    const res = await api("get", Constants.END_POINT.USERS);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.USERS,
                payload: res.data,
            });
        }
    }
    if (setLoading) {
        setLoading(false);
    }
};

const EnableDisableUserAction = (id) => async (dispatch) => {
    const res = await api("get", Constants.END_POINT.ENABLE_DISABLE_USER + id);
    if (res.success) {
        dispatch(getUsers());
        dispatch(showToast({ severity: "success", summary: res.message }));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
};

const getUser = (id, returnData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.USER + id);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            if (returnData) {
                returnData(res.data);
            }
        }
    }
    dispatch(hideLoaderAction());
};

const editUser = (id, data, setLoading, history) => async (dispatch) => {
    setLoading(true);
    let image;
    if (data.image) {
        image = await uploadImages([data.image]);
    }
    const payload = {
        ...data,
        image: image ? image[0] : "",
    };

    const res = await api("put", Constants.END_POINT.UPDATE_USER + id, payload);
    if (res.success) {
        getUsers(null);
        history.goBack();
        dispatch(showToast({ severity: "success", summary: res.message }));
    }
    setLoading(false);
};

const deleteUser = (id) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.DELETE_USER + id);
    if (res.success) {
        dispatch(getUsers());
        dispatch(showToast({ severity: "success", summary: res.message }));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

export { getUsers, getUser, EnableDisableUserAction, editUser, deleteUser };
